import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import HideForMobile from '@/components/shared/HideForMobile';
import CourseBoxMain from '@/components/_deprecated/courses/box/CourseBoxMain';
import CourseBoxHeaderForm from '@/components/_deprecated/courses/box/header/CourseBoxHeader';
import { CourseBoxMainSkeleton } from '@/components/_deprecated/courses/box/skeletons/CourseBoxSkeletons';
import Layout from '@/components/template/Layout';
import { useCoursePath } from '../studio/CourseStudio.hooks';
import CourseStudioBreadcrumb from '../studio/CourseStudioBreadcrumb';

export default function CourseBox() {
  const { coursePath, isLoading: loadingCoursePath } = useCoursePath();

  return (
    <HideForMobile>
      <Layout>
        <section className="flex flex-col gap-4">
          <CourseStudioBreadcrumb
            courseName={coursePath?.course?.name}
            loading={loadingCoursePath}
          />

          <CourseBoxHeaderForm
            coursePath={coursePath}
            isLoading={loadingCoursePath}
          />
        </section>
        <ConditionalRenderer condition={loadingCoursePath}>
          <CourseBoxMainSkeleton />
        </ConditionalRenderer>
        {coursePath && <CourseBoxMain coursePath={coursePath} />}
      </Layout>
    </HideForMobile>
  );
}
